import { render, staticRenderFns } from "./ExpertisePageCreate.vue?vue&type=template&id=0f08c424&"
import script from "./ExpertisePageCreate.vue?vue&type=script&lang=ts&"
export * from "./ExpertisePageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f08c424')) {
      api.createRecord('0f08c424', component.options)
    } else {
      api.reload('0f08c424', component.options)
    }
    module.hot.accept("./ExpertisePageCreate.vue?vue&type=template&id=0f08c424&", function () {
      api.rerender('0f08c424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Expertises/ExpertisePageCreate.vue"
export default component.exports